// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  
  try {
    // Decode JWT to check expiration (basic check)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const isExpired = payload.exp && payload.exp * 1000 < Date.now();
    
    if (isExpired) {
      // Token expired, clear it
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return false;
    }
    
    return true;
  } catch (error) {
    // Invalid token format
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return false;
  }
};

// Clear authentication
export const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
